import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { saveStockPublicationSettings } from "../../api/thunks/saveStockPublicationSettings";
import { cloneSettings } from "../../lib/cloneSettings";
import { StockPublicationSliceState } from "../../types";

export const addSaveSettingsExtraReducers = (
  builder: ActionReducerMapBuilder<StockPublicationSliceState>,
) => {
  builder
    .addCase(saveStockPublicationSettings.pending, (state) => {
      state.isSaving = true;
      state.error = null;
    })
    .addCase(saveStockPublicationSettings.fulfilled, (state, action) => {
      state.isSaving = false;
      state.savedSettings = action.payload;
      state.draftSettings = cloneSettings(action.payload);
    })
    .addCase(saveStockPublicationSettings.rejected, (state, action) => {
      state.isSaving = false;
      state.error = action.payload ?? "Ошибка сохранения";
    });
};
